/* eslint-disable jira/filename-case */
import React, { type ComponentType } from 'react';
import { type WithIntlProps, defineMessage } from '@atlassian/jira-intl';
import { ModalDialog } from '@jira/software__modal-dialog/src/ModalDialog.tsx';
import ModalTransition from '@atlaskit/modal-dialog/modal-transition';
import ModalBody from '@atlaskit/modal-dialog/modal-body';
import ModalTitle from '@atlaskit/modal-dialog/modal-title';
import ModalHeader from '@atlaskit/modal-dialog/modal-header';
import ViewTracker from '@jira/platform__analytics-web-react/src/components/view-tracker.tsx';
import ShortcutScope from '@jira/platform__common-components-keyboard-shortcuts/src/shortcut-scope.tsx';
import { type IntlShape, injectIntl } from '@atlassian/jira-intl/src/index.tsx';
/* eslint-disable jira/filename-case */
// eslint-disable-next-line no-restricted-imports
const title: { id: string; defaultMessage: string; description: string } = defineMessage({
	id: 'directories.filters-v2.delete-modal.title',
	defaultMessage: 'Delete {name}',
	description: 'Title for delete filter modal.',
});

export type Props = {
	isOpen: boolean;
	// oxlint-disable-next-line @typescript-eslint/no-explicit-any
	Footer: ComponentType<Record<any, any>>;
	// oxlint-disable-next-line @typescript-eslint/no-explicit-any
	Content: ComponentType<Record<any, any>>;
	name: string;
	onCancel: () => void;
	intl: IntlShape;
};

const DeleteModal = ({
	intl: { formatMessage },
	isOpen,
	Content,
	Footer,
	onCancel,
	name,
}: Props) => (
	<ModalTransition>
		{isOpen && (
			<ShortcutScope>
				<ModalDialog
					// eslint-disable-next-line jira/choreographer/message-id-by-folder-structure
					messageId="delete-filters-modal.modal-dialog"
					messageType="transactional"
					width="small"
					onClose={onCancel}
				>
					<ModalHeader hasCloseButton>
						<ModalTitle appearance="danger">{formatMessage(title, { name })}</ModalTitle>
					</ModalHeader>
					<ModalBody>
						<Content />
						<ViewTracker />
					</ModalBody>
					<Footer onClose={onCancel} />
				</ModalDialog>
			</ShortcutScope>
		)}
	</ModalTransition>
);

const DeleteFiltersModalView: React.FC<WithIntlProps<Props>> & {
	WrappedComponent: React.ComponentType<Props>;
} = injectIntl(DeleteModal);
export default DeleteFiltersModalView;
